(function(){
  document.addEventListener('DOMContentLoaded', function() {
    window.updateVideoSource = function updateVideoSource() {
        var videoElements = document.querySelectorAll(".video_for_change");
        if (!videoElements) return; // Exit if the video element is not found
        videoElements.forEach(elem => {
           var videoSource = elem.querySelector("source");
          if (!videoSource) return; // Exit if the source element is not found
  
          var mobileVideoSrc = elem.getAttribute("data-source-check");
  
          // Store the original video source only once
          if (!videoSource.hasAttribute("data-default-src")) {
              videoSource.setAttribute("data-default-src", videoSource.getAttribute("src"));
          }
          var defaultVideoSrc = videoSource.getAttribute("data-default-src");
        
          // If screen width is less than 767, use the mobile video
          if (window.innerWidth < 767) {
              if (videoSource.getAttribute("src") !== mobileVideoSrc) {
                  videoSource.setAttribute("src", mobileVideoSrc);
                  elem.load(); // Reload video for new source
              }
          } 
          // If screen width is 767 or more, switch back to default
          else {
              if (videoSource.getAttribute("src") !== defaultVideoSrc) {
                  videoSource.setAttribute("src", defaultVideoSrc);
                  elem.load(); // Reload video for new source
              }
          }
        });
       
    }

    // setTimeout(updateVideoSource, 100);
    window.updateVideoSource();
    window.addEventListener("resize", updateVideoSource);
  }, false);
})();